<template>
  <div
    class="tarjeta-cliente shadow mb-4 bg-white"
    @click="Habilitar(prospectoId)"
  >
    <div class="row">
      <div class="col-12 tarjeta-cliente__contenedor-nombre">
        <div class="tarjeta-cliente__contenedor-datos">
          <small
            ref="redirigePantalla"
            class="tarjeta-cliente__nombre nombre-cliente"
          >
            {{ nombreCompleto }}
          </small>
          <small class="tarjeta-cliente__nombre monto-cliente">
          {{ DarFormatoMoneda(montoDeseado) }}
          </small>
        </div>
        <div class="d-flex">
          <label class="tarjeta-cliente__fecha">
            Motivo de Baja: {{ motivo }}
          </label>
        </div>
         <div class="d-flex">
          <label class="tarjeta-cliente__fecha">
            Observaciones: {{ observaciones }}
          </label>
        </div>
        <div class="d-flex">
          <label class="tarjeta-cliente__fecha">
            <!--Fecha de baja: {{ DarFormatoFecha(fechaBaja) }}-->
            Fecha de baja: {{ fechaBaja }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

import servicios from "../../../servicios/service.js";

export default {
  name: "TarjetaPausadosCancelados",
  components: {},
  data() {
    return {
      tipoUsuario: null
    }
  },
  props: {
    prospectoId: Number,
    contratadoId: Number,
    nombreCompleto: String,
    montoDeseado: Number,
    fechaBaja: String,
    motivo: String,
    observaciones: String,
  },
  mounted(){
    this.tipoUsuario = this.$store.getters.tipoUsuario;
  },
  methods: {
    DarFormatoMoneda(montoDeseado){
      return servicios.DarFormatoMoneda(montoDeseado);
    },
    // DarFormatoFecha(fecha){
    //   let fechaFormateada =  fecha.substring(8,10)  + "/" + fecha.substring(5,7) + "/" + fecha.substring(0,4);
    //   return fechaFormateada;
    // },
    Habilitar(prospectoId){
      if(this.tipoUsuario == 5){
          // this.$store.commit('setProspecto', prospectoId);
          // this.$router.push({name: 'CajaDorada'});
          console.log("Entro a la reactivacion: " + prospectoId);
      } else {
          this.AlertaEmbajadores('No puede reactivar al usuario. Contacte al gerente o administrador de suscursal.',true, false);
      }
    }
  }
};
</script>

<style scoped lang="scss">
$color-primario: #b8725a;
$color-textos: #696158;
$poppins: "Poppins";
$negro: #000000;

.tarjeta-cliente {
  cursor: pointer;
  width: 100%;
  margin-top: 5px;
  border-left: 7px solid $color-primario;
  border-radius: 0px;
}
.tarjeta-cliente:hover {
  transform: scale(1.02);
  transition: all 0.2s ease-in-out;
}
.tarjeta-cliente__contenedor-nombre {
  text-align: initial;
}

.tarjeta-cliente__contenedor-datos {
  display: flex;
  justify-content: space-between;
}

.tarjeta-cliente__nombre {
  cursor: pointer;
  font-family: $poppins;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  letter-spacing: 0.05em;
  color: $negro;
}
.nombre-cliente {
  padding-left: 20px;
}
.monto-cliente {
  font-weight: bold;
  padding-right: 30px;
}
.tarjeta-cliente__row-datos {
  margin-top: 10px;
  margin-bottom: 10px;
}
.tarjeta-cliente__fecha {
  padding: 20px;
  color: black;
  font-size: 16px;
  font-weight: 500;
  font-family: "Poppins";
}
@media all and (max-width: 767px) {
  .tarjeta-cliente__contenedor-datos {
    display: flex;
    justify-content: space-evenly;
  }
  .nombre-cliente {
    padding-left: 0;
  }
  .monto-cliente {
    padding-right: 0;
  }
  .tarjeta-cliente__fecha {
    padding: 20px;
    font-size: 14px;
    text-align: left;
  }
  .tarjeta-cliente__contenedor-nombre {
    text-align: center;
  }
  .contenedor-icono-p i {
    padding-right: 20px;
    font-size: 20px;
  }
  .tarjeta-cliente__row-datos {
    margin-top: 10px;
  }
  .tarjeta-cliente__row-datos .row-cols-12 {
    max-width: 150% !important;
    margin-top: 10px;
  }

  .tarjeta-cliente__nombre {
    font-size: 13px;
  }
}
</style>
